<template>
  <div class="form form_w460">
    <div class="form__head">
      <div class="form__title form__title_white mb10">
        {{$t('modals.details')}}
        <button
          type="reset"
          class="form__address-close js-btn-close"
          @click="close"
        >
          <img src="@/assets/images/close.svg" width="24px" alt />
        </button>
      </div>
    </div>

    <div class="form__content">
      <div class="form-item form-item_flex form-item_center mb40">
        <img src="@/assets/images/Info24px.svg" alt="info" width="74px" height="74px" />
      </div>

      <div class="form-item form-item_center mb40">
        <p
          class="form-item__text_black form-item__text_foz20 mb16"
        >{{$t('alerts.serviceDetails', {price: getFormattedPrice(service.price, true)})}}</p>
        <p
          class="form-item__text_black form-item__text_foz20 mb16"
        >{{$t('alerts.serviceDetails_15', {price_fifteen: getFormattedPrice(service.price_fifteen)})}}</p>
        <p
          class="form-item__text_black form-item__text_foz20"
        >{{$t('alerts.serviceDetailsTrip', {trip})}}</p>
      </div>

      <!-- <div class="form-item form-item_flex form-item_center buttons buttons_mt">
        <button class="btn btn_upper js-btn-cancel" @click="close">{{$t('buttons.gotIt')}}</button>
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "details-modal",
  props: {
    service: {
      required: false
    }
  },
  computed: {
    isProfy() {
      return this.$config.project == "profy";
    },
    trip() {
      return this.isProfy ? 26 : 39;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    getFormattedPrice(price, hasTravelTime = false) {
      const travelPrice = this.trip;
      const vat = Math.ceil((price * 20) / 120);
      price = price - vat;

      if (hasTravelTime) {
        price = price - travelPrice;
      }
      return price;
    }
  }
};
</script>

<style lang="scss" scoped>
.form__address-close {
  background: transparent;
  border: none;
  position: absolute;
  right: 0;
  padding: 0;
  outline: none;
  cursor: pointer;
}
</style>